import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, Zap } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { BookMockup } from './BookMockup';
import { PaymentIcons } from './PaymentIcons';
export function Hero() {
  return <section className="relative pt-20 pb-24 overflow-hidden bg-radial-glow" data-id="element-71">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 relative z-10" data-id="element-72">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-73">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="flex flex-col items-center lg:items-start text-center lg:text-left" data-id="element-74">
            <div className="inline-block px-4 py-1.5 rounded-full border border-brand-gold/30 bg-brand-gold/10 text-brand-gold text-sm font-semibold tracking-wide mb-6" data-id="element-75">
              DESCUBRE EL PROTOCOLO MASCULINO Y RECUPERA TU BUEN SEXO.
            </div>

            <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6" data-id="element-76">
              ¿Quieres recuperar la firmeza real de tus erecciones?
            </h1>

            <p className="text-xl sm:text-2xl text-brand-text/90 font-medium mb-6 leading-relaxed" data-id="element-77">
              Recupera la potencia, la confianza y el rendimiento de tus mejores
              años.
            </p>

            <p className="text-base sm:text-lg text-brand-muted mb-10 leading-relaxed max-w-2xl" data-id="element-78">
              Descubre el : El primer protocolo integral diseñado para hombres
              que quieren eliminar la ansiedad, optimizar sus hormonas y volver
              a disfrutar de una virilidad inquebrantable. Descubre todo lo que
              debes saber y hacer para tener una erección firme y por más
              tiempo... .
            </p>

            <div className="w-full max-w-md lg:max-w-none" data-id="element-79">
              <CtaButton data-id="element-80" />

              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mt-6 text-sm text-brand-muted font-medium" data-id="element-81">
                <div className="flex items-center gap-2" data-id="element-82">
                  <Lock className="w-4 h-4 text-brand-gold" data-id="element-83" />
                  <span data-id="element-84">Pago seguro</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-85">
                  <Zap className="w-4 h-4 text-brand-gold" data-id="element-86" />
                  <span data-id="element-87">Acceso inmediato</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-88">
                  <Shield className="w-4 h-4 text-brand-gold" data-id="element-89" />
                  <span data-id="element-90">Garantía 7 días</span>
                </div>
              </div>

              <PaymentIcons data-id="element-91" />
            </div>
          </motion.div>

          <div className="flex justify-center lg:justify-end mt-8 lg:mt-0" data-id="element-92">
            <BookMockup data-id="element-93" />
          </div>
        </div>
      </div>

      {/* Decorative divider */}
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-brand-gold/30 to-transparent" data-id="element-94"></div>
    </section>;
}